// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CameraFilledSvg from "@fishx/icons-svg/es/asn/CameraFilled";
import FishxIcon from '../components/FishxIcon';

var CameraFilled = function CameraFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CameraFilledSvg
  }));
};

CameraFilled.displayName = 'CameraFilled';
export default React.forwardRef(CameraFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CameraFilled.js
// module id = 2156
// module chunks = 0